import React from 'react'
import './footer.css';

const Footer = () => {
  return (
    <footer className="footer">
        <div className="footer_container container">
            <h1 className="footer_title">Dustine Gutierrez</h1>
            <ul className="footer_list">
                <li>
                    <a href="#about" className="footer_link">About</a>
                </li>
                <li>
                    <a href="#skills" className="footer_link">Skills</a>
                </li>
                <li>
                    <a href="#portfolio" className="footer_link">Projects</a>
                </li>
                <li>
                    <a href="#contact" className="footer_link">Contact</a>
                </li>
                {/* <li>
                    <a href="#testimonials" className="footer_link">Testimonials</a>
                </li> */}
            </ul>
            <div className="footer_social">
                <a 
                href="https://www.linkedin.com/in/dcggutierrez/"
                className="footer_social-link" 
                target={"_blank"}
                rel="noreferrer">
                <i className="bx bxl-linkedin"></i>
                </a>
                <a 
                href="https://github.com/dcggutierrez"
                className="footer_social-link" 
                target={"_blank"}
                rel="noreferrer">
                <i className="bx bxl-github"></i>
                </a>
            </div>
        </div>
    </footer>
  )
}

export default Footer